import queryString from 'query-string';
import { API_URL, SUBSCRIPTION_KEY, BFF_API_ROOT_URL } from '../../config/environment';
import { acquireAccessToken } from 'auth/hooks/authProvider';
import store from '../store';

const apiUrl = API_URL.substr(-1) === '/' ? API_URL.slice(0, -1) : API_URL;

async function AuthorizedHeaders() {
  const headers = new Headers();
  const token = await acquireAccessToken();

  headers.append('Authorization', `Bearer ${token}`);
  headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
  headers.append('Content-Type', 'application/json');
  headers.append('x-signalr-id', store.getState().signalR.id);
  return headers;
}

function Parameters(query) {
  let parameters = '';
  if (query) {
    parameters = queryString.stringify(query);
  }
  return parameters && '?' + parameters;
}

export async function Get(resource, query) {
  return new Request(apiUrl + resource + Parameters(query), {
    method: 'GET',
    headers: await AuthorizedHeaders(),
  });
}

export async function GetWeb(resource, query) {
  return new Request(BFF_API_ROOT_URL + resource + Parameters(query), {
    method: 'GET',
    headers: await AuthorizedHeaders(),
  });
}

export async function GetBase(baseUrl, resource, query) {
  return new Request(baseUrl + resource + Parameters(query), {
    method: 'GET',
    headers: await AuthorizedHeaders(),
  });
}

export async function Put(resource, body) {
  return new Request(apiUrl + resource, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: await AuthorizedHeaders(),
  });
}

export async function Post(resource, body) {
  return new Request(apiUrl + resource, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: await AuthorizedHeaders(),
  });
}

export async function PostWeb(resource, body) {
  return new Request(BFF_API_ROOT_URL + resource, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: await AuthorizedHeaders(),
  });
}

export async function Delete(resource, body) {
  return new Request(apiUrl + resource, {
    method: 'DELETE',
    body: JSON.stringify(body),
    headers: await AuthorizedHeaders(),
  });
}
